module.exports = __webpack_public_path__ + "img/pdf.24bafae3.png";